import { IAppState } from "../../../../app/appTypes"
import { IConsent } from "../../../../features/liveMeeting/state/liveMeetingTypes"

export const getLiveMeetingUserConsent = (state: IAppState, userId: string): IConsent => state.liveMeetingConfig.consents[userId]

export const getLiveMeetingConsents = (state: IAppState): { [userId: string]: IConsent } => state.liveMeetingConfig.consents
